import { render, staticRenderFns } from "./order-payment-details-message.vue?vue&type=template&id=6badd2ce"
import script from "./order-payment-details-message.vue?vue&type=script&lang=js"
export * from "./order-payment-details-message.vue?vue&type=script&lang=js"
import style0 from "./order-payment-details-message.vue?vue&type=style&index=0&id=6badd2ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports